import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import SEOHead from '../components/SEOHead';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [status, setStatus] = useState({
    submitting: false,
    submitted: false,
    error: null
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ submitting: true, submitted: false, error: null });

    try {
      // Configuration EmailJS depuis les variables d'environnement
      const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID || 'service_contact_mdi';
      const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'template_contact_mdi';
      const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || 'YOUR_PUBLIC_KEY';

      // Vérification de la configuration
      if (publicKey === 'YOUR_PUBLIC_KEY') {
        throw new Error('EmailJS non configuré. Veuillez consulter CONTACT_SETUP.md');
      }

      // Paramètres du template
      const templateParams = {
        from_name: formData.name,
        from_email: formData.email,
        subject: formData.subject,
        message: formData.message,
        to_email: 'webkoda.team@gmail.com',
        source: 'https://mon-depannage-informatique.fr/',
        reply_to: formData.email
      };

      // Envoi via EmailJS
      await emailjs.send(
        serviceId,
        templateId,
        templateParams,
        publicKey
      );

      setStatus({ submitting: false, submitted: true, error: null });
      setFormData({ name: '', email: '', subject: '', message: '' });
    } catch (error) {
      console.error('Erreur EmailJS:', error);
      setStatus({
        submitting: false,
        submitted: false,
        error: 'Une erreur est survenue. Veuillez réessayer ou nous contacter directement par téléphone '
      });
    }
  };

  return (
    <>
      <SEOHead
        title="Contact - Excellence Informatique | Dépannage à Nantes"
        description="Contactez Excellence Informatique pour tous vos besoins en dépannage informatique à Nantes. Formulaire de contact, téléphone et email disponibles."
        canonical="https://mon-depannage-informatique.fr/contact"
        keywords="contact, dépannage informatique, Nantes, assistance, support technique"
      />

      <div className="contact-page">
        <div className="container">
          <div className="contact-header">
            <h1>Contactez-nous</h1>
            <p>Une question ? Un problème informatique ? N'hésitez pas à nous contacter !</p>
          </div>

          <div className="contact-content-wrapper">
            
            <div className="contact-form-section">
              <h2>Envoyez-nous un message</h2>

              {status.submitted && (
                <div className="success-message">
                  ✓ Votre message a été envoyé avec succès ! Nous vous répondrons dans les plus brefs délais.
                </div>
              )}

              {status.error && (
                <div className="error-message">
                  ✗ {status.error}
                </div>
              )}

              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-group">
                  <label htmlFor="name">Votre nom *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Thomas Smith"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Votre e-mail *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="thomas.smith@example.com"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="subject">Objet *</label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    placeholder="Dépannage ordinateur"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Votre message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="6"
                    placeholder="Décrivez votre problème ou votre demande..."
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="submit-btn"
                  disabled={status.submitting}
                >
                  {status.submitting ? 'Envoi en cours...' : 'Envoyer le message'}
                </button>

                <p className="form-note">
                  * Champs obligatoires. Vos données sont traitées de manière confidentielle.
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
